exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-43ecf86f].table-full .v-datatable.v-table>tbody{max-height:calc(100vh - 426px);min-height:calc(100vh - 426px)}[data-v-43ecf86f] tbody tr:hover:not(.v-datatable__expand-row){background-color:#eee!important}", ""]);

// exports
